/*
  Number formatting for every count on the site (§6.2).

  The locale is pinned to en-US, not left to the visitor. A bare toLocaleString() prints
  11.811 for a de-DE visitor, and this is a public site read from anywhere.
*/

const countFormatter = new Intl.NumberFormat("en-US");

/* A null count is a count the cache could not produce; it displays as 0 (§4.2). */
export const formatCount = (value: number | null | undefined): string => {
  if (typeof value !== "number" || !isFinite(value)) {
    return countFormatter.format(0);
  }
  return countFormatter.format(value);
};
